// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Delivery24Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Delivery24: FC<Delivery24Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="24"
            height="24"
        >
            <path d="M6 20a2.893 2.893 0 0 1-2.125-.875A2.893 2.893 0 0 1 3 17H1V6c0-.55.196-1.02.587-1.412A1.926 1.926 0 0 1 3 4h14v4h3l3 4v5h-2c0 .833-.292 1.542-.875 2.125A2.893 2.893 0 0 1 18 20a2.893 2.893 0 0 1-2.125-.875A2.893 2.893 0 0 1 15 17H9c0 .833-.292 1.542-.875 2.125A2.893 2.893 0 0 1 6 20Zm0-2c.283 0 .52-.096.713-.288A.968.968 0 0 0 7 17a.968.968 0 0 0-.287-.712A.967.967 0 0 0 6 16a.967.967 0 0 0-.713.288A.968.968 0 0 0 5 17c0 .283.096.52.287.712.192.192.43.288.713.288Zm-3-3h.8c.283-.3.608-.542.975-.725A2.701 2.701 0 0 1 6 14c.45 0 .858.092 1.225.275.367.183.692.425.975.725H15V6H3v9Zm15 3c.283 0 .52-.096.712-.288A.968.968 0 0 0 19 17a.968.968 0 0 0-.288-.712A.968.968 0 0 0 18 16a.968.968 0 0 0-.712.288A.968.968 0 0 0 17 17c0 .283.096.52.288.712.191.192.429.288.712.288Zm-1-5h4.25L19 10h-2v3Z" />
        </svg>
    );
};

export default Delivery24;
